import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading, SectionCta } from "./Reveal";

const FAQS = [
  {
    q: "Is this HIPAA compliant?",
    a: "Our coordinators are HIPAA-trained and work inside your compliance rules from day one. [BAA AND COMPLIANCE DETAILS PLACEHOLDER]",
  },
  {
    q: "Will they sound like my clinic?",
    a: "Yes. Your coordinator trains on your services, your language and your patients, not a generic script. Your account manager reviews recorded calls every week, so quality is checked before you ever notice a problem.",
  },
  {
    q: "What happens with pricing questions?",
    a: "We follow your rules. Coordinators never quote numbers you have not approved. Callers get a helpful answer and a reason to book the consult, where pricing is handled properly.",
  },
  {
    q: "How fast is onboarding?",
    a: "Most practices go live within [X] days. Onboarding covers your scripts, offers, systems access and test calls before we ever touch a real patient.",
  },
  {
    q: "Which CRM do you use?",
    a: "Yours. The Engine runs inside your GoHighLevel or existing CRM, so your data stays with your practice.",
  },
  {
    q: "What if I already have a front desk?",
    a: "Keep them. The Engine covers overflow, after hours, weekends and follow-up, the work that slips when the desk gets busy. Your team focuses on the patients standing in front of them.",
  },
  {
    q: "Is there a contract?",
    a: "[CONTRACT TERMS PLACEHOLDER]",
  },
  {
    q: "What if it doesn't work?",
    a: "You get daily measurement, weekly call reviews and a monthly scorecard, so problems surface fast. Your account manager owns the result. [GUARANTEE TERMS PLACEHOLDER]",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-36 bg-coal border-y border-black/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <SectionHeading
          eyebrow="Before you book"
          title={
            <>
              The questions every owner asks, <span className="italic text-champagne">answered straight.</span>
            </>
          }
          copy="Anything else, bring it to the audit call. You will get a direct answer either way."
        />
      </div>
      <div className="lg:col-span-7">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-black/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-xl md:text-2xl font-light text-pearl hover:text-champagne hover:no-underline py-7 transition-colors duration-300"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-zinc-600 font-light leading-relaxed pb-7 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <SectionCta id="faq" label="Ask me anything on the call" />
      </div>
    </div>
  </section>
);
